<template>
    <div :class="containerClasses">
        <div :class="headerClasses">
            <div class="row align-items-center">
                <div class="col-sm">
                    <h4 class="font-weight-light mb-0">{{ heading }}</h4>
                </div>
                <div class="col-sm-auto ml-auto">
                    <button :class="carouselButtonClasses" :data-target="'#' + carouselId" data-slide="prev">
                        <span class="fa fa-chevron-left align-middle icons icon-arrow-left" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </button>
                    <button :class="carouselButtonClasses" :data-target="'#' + carouselId" data-slide="next">
                        <span class="fa fa-chevron-right align-middle icons icon-arrow-right" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </button>
                </div>
            </div>
        </div>
        <div :id="carouselId" class="carousel slide my-auto w-100" data-ride="carousel" :data-interval="carouselInterval">
            <div class="carousel-inner rounded-lg" role="listbox">
                <div v-for="(item,key) in itemList" :class="(key===0)?'carousel-item active':'carousel-item'" :key="key">
                    <div class="card rounded-lg border-0">
                        <div class="row align-items-center no-gutters">
                            <div class="col-md-4 col-lg-4 col-xl-4 col-12">
                                <div class="w-100 p-3">
                                    <img class="rounded-circle img-fluid mx-auto d-block bg-light" :src="item.pic" alt="profile pic" />
                                </div>
                            </div>
                            <div class="col-md-8 col-lg-8 col-xl-8 col-12">
                                <div :class="'card-body ' + contentClasses">
                                    <h3 class="mb-0">{{ item.name }}</h3>
                                    <span class="text-muted font-weight-normal">@{{ item.username }}</span>
                                    <p class="mt-1 text-truncate">{{ item.short }}</p>
                                    <div class="row">
                                        <div :class="'col-12 ' + countClasses">
                                            <div class="row">
                                                <div class="col-4 py-1">
                                                    <h4 class="mb-0 text-truncate">{{ item.likes }}</h4>
                                                    <a :href="likesLink" class="d-block small text-uppercase text-truncate">likes</a>
                                                </div>
                                                <div class="col-4 border-left border-right py-1">
                                                    <h4 class="mb-0 text-truncate">{{ item.posts }}</h4>
                                                    <a :href="postsLink" class="d-block small text-uppercase text-truncate">posts</a>
                                                </div>
                                                <div class="col-4 py-1">
                                                    <h4 class="mb-0 text-truncate">{{ item.friends }}</h4>
                                                    <a :href="friendsLink" class="d-block small text-uppercase text-truncate">friends</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import profiles from '../data/profiles.json';

export default {
    props: {
        containerClasses: {
            type: String,
            default: "card shadow-sm rounded-lg"
        },
        carouselId: {
            type: String,
            default: "sliderProfiles"
        },
        carouselInterval: {
            type: Number,
            default: 5000
        },
        carouselButtonClasses: {
            type: String,
            default: "btn btn-outline-primary btn-sm ml-2"
        },
        heading: {
            type: String,
            default: "Profiles"
        },
        items: {
            type: Array,
            default(){
                return profiles;
            }
        },
        headerClasses: {
            type: String,
            default: "card-header bg-transparent border-bottom-0"
        },
        contentClasses: {
            type: String,
            default: "text-center text-truncate py-4"
        },
        headingClasses: {
            type: String,
            default: "mb-0"
        },
        buttonClasses: {
            type: String,
            default: "btn btn-primary"
        },
        countClasses: {
            type: String,
            default: "text-center"
        }
    },
    
    data() {
        return {
          itemList: this.items||[]
        };
    }
};
</script>
